import { getParam } from '../../helpers/parameters'
import uniqBy from 'lodash/uniqBy'

const count = 4

export const fetchRelatedApi = async ({
  contentType,
  id,
  language,
  currentPhoneId,
  customer,
  preSaleURL
}) => {
  const suggestedApiUrl = await getParam('suggestedContentApiUrl')
  const suggestedApiV2Url = await getParam('suggestedContentV2ApiUrl')
  const v2res = await fetch(
    `${suggestedApiV2Url}/suggested_content` +
      `?datatype=${contentType}&id=${id}&language=${language}` +
      `&phone=${currentPhoneId}&customer=${customer}` +
      `&count=${count}${preSaleURL}`
  ).then(req => req.json())
  const enhancedV2res = v2res.map(r => ({
    ...r,
    isSameDevice: Number(r.device) === Number(currentPhoneId)
  }))
  const origRes = await fetch(
    `${suggestedApiUrl}/suggested_content` +
      `?datatype=${contentType}&id=${id}&language=${language}` +
      `&phone=${currentPhoneId}&customer=${customer}` +
      `&count=${count}${preSaleURL}`
  ).then(res => res.json())
  return uniqBy(enhancedV2res.concat(origRes), 'contentTitle')
}

export const fetchInlineRelatedApi = async ({
  contentType,
  id,
  language,
  currentPhoneId
}) => {
    const composerApiUrl = await getParam('composerApiUrl')
  return fetch(
    `${composerApiUrl}/academy/related/` +
      `${contentType}s?id=${id}&language=${language}` +
      `&phoneId=${currentPhoneId}`
  ).then(req => req.json())
}

export const apiFetchSwimlaneContent = async (
  currentPhoneId,
  preSaleFlag,
  language,
  customer
) => {
  const suggestedContentApiUrl = await getParam('suggestedContentApiUrl')
  const preSaleURL = preSaleFlag ? '&presales=1' : ''
  return fetch(
    `${suggestedContentApiUrl}/swimlane` +
      `?count=4&language=${language}&phone=${currentPhoneId}` +
      `&customer=${customer}${preSaleURL}`
  ).then(req => req.json())
}



// WEBPACK FOOTER //
// ./src/containers/RelatedSidebar/services.js